import React from 'react';
import { BsBatteryFull } from 'react-icons/bs';
import { AiOutlineWifi } from 'react-icons/ai';
import { FaSignal } from 'react-icons/fa';
import { png } from 'utils/imgList';

import * as S from './styles';
import { color } from 'styles/pallete';
interface MobileBodyProps {
	children: React.ReactNode;
	withPaddingContent?: boolean; // se quiser padding em todo container onde vai o children
	useBackground?: boolean;
	backgroundUrl?: string | null;
	backgroundColor?: string;
	isShadow?: boolean; //sombra em volta do celular
	heightCellPhone?: string;
	heightContentPhone?: string;
	widthCellPhone?: string;
	showFaceId?: boolean; // mostra a "notch" do celular
	textTitle?: string;
	showHeaderPhone?: boolean;
}

export default function MobileBody({
	children,
	withPaddingContent = false,
	useBackground = false,
	backgroundUrl = png.iosWallpaper,
	backgroundColor = color.interface.white,
	isShadow = false,
	heightCellPhone = '520px',
	widthCellPhone = '270px',
	showFaceId = true,
	textTitle = '',
	showHeaderPhone = true,
	heightContentPhone = '94%'
}: MobileBodyProps) {
	return (
		<S.container>
			{textTitle !== '' && <S.title>{textTitle}</S.title>}
			<S.containerMobile
				$useBackground={useBackground}
				$background={backgroundUrl}
				$isShadow={isShadow}
				$backgroundColor={backgroundColor}
				$heightCellPhone={heightCellPhone}
				$widthCellPhone={widthCellPhone}
			>
				{showHeaderPhone && (
					<S.topMobile $useBackground={useBackground}>
						<S.operadoraCell $useBackground={useBackground}>
							<p>Mondelez</p>
						</S.operadoraCell>
						<S.blackDiv $isShow={showFaceId} />
						<S.iconsCell $useBackground={useBackground}>
							<AiOutlineWifi style={{ fontSize: '15px' }} />
							<FaSignal style={{ fontSize: '13px' }} />
							<BsBatteryFull style={{ fontSize: '15px' }} />
						</S.iconsCell>
					</S.topMobile>
				)}

				<S.contentPhone
					$useBackground={useBackground}
					$withPaddingContent={withPaddingContent}
					$backgroundColor={backgroundColor}
					$showHeaderPhone={showHeaderPhone}
					$heightContentPhone={heightContentPhone}
				>
					{children}
				</S.contentPhone>
			</S.containerMobile>
		</S.container>
	);
}
